import d, { css as r } from "styled-components";
import { breakpoints as n } from "./atoms-v2125.js";
import { Text as a } from "./atoms-v243.js";
import { Link as c } from "./atoms-v224.js";
const g = d.div`
  display: flex;
  flex-direction: column;
`, $ = d.div`
  align-items: center;
  background-color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.surface.${o}.layer01`)};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  padding-block: 24px;

  @media ${n.medium} {
    padding-block: 32px;
  }

  @media ${n.large} {
    padding-block: 48px;
  }

  ${({ $hasDueLater: o }) => o && r`
      @media ${n.medium} {
        gap: 10px;
      }

      @media ${n.large} {
        gap: 12px;
      }
    `}
`, x = d.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`, k = d(a)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.04").toJS()};

  @media ${n.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.05").toJS()};
  }

  @media ${n.large} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.06").toJS()};
  }
`, u = d(a)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.productive").toJS()};

  @media ${n.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};
  }
`, y = d.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 24px;
  width: 100%;

  @media ${n.medium} {
    padding: 0 40px;
  }
`, f = d.div`
  align-items: center;
  background-color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.surface.${o}.background`)};
  border-radius: 4px;
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 0 20px;
`, b = d(a)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};

  @media ${n.large} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-expressive").toJS()};
  }
`, S = d(a)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};

  @media ${n.large} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-expressive").toJS()};
  }
`, v = d.div`
  align-self: center;
  background-color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.surface.${o}.layer01`)};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
  padding: 16px;
  width: 100%;

  @media ${n.medium} {
    gap: 20px;
    padding: 24px;
  }

  @media ${n.large} {
    gap: 24px;
  }
`, J = d.div`
  border-bottom: 1px solid ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.border.${o}.light`)};
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 0 12px;

  @media ${n.medium} {
    gap: 4px;
    padding: 0 0 16px;
  }
`, e = d.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  @media ${n.medium} {
    gap: 4px;
  }
`, P = d(a)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.compact-01").toJS()};

  @media ${n.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.compact-02").toJS()};
  }
`, T = d.div`
  display: flex;
  justify-content: space-between;
`, w = d(a)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.secondary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.productive").toJS()};

  @media ${n.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.productive").toJS()};
  }
`, I = d(a)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.secondary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.productive").toJS()};

  @media ${n.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.01").toJS()};
  }
`, j = d(a)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.productive").toJS()};

  @media ${n.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.compact-01").toJS()};
  }
`, B = d(a)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.secondary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.xs-productive").toJS()};

  @media ${n.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.productive").toJS()};
  }
`, H = d(c)`
  align-self: center;
`;
export {
  H as AlignedLink,
  e as CancellationPolicySection,
  B as CancellationPolicyText,
  j as CancellationPolicyTitle,
  $ as Header,
  f as ItemInHeader,
  S as ItemInHeaderPrice,
  b as ItemInHeaderText,
  k as MainTitlePrice,
  x as MainTitleSection,
  u as MainTitleText,
  v as PriceBreakdown,
  T as PriceBreakdownItem,
  I as PriceBreakdownItemPrice,
  w as PriceBreakdownItemText,
  J as PriceBreakdownSection,
  y as SectionWithDueLater,
  P as TotalPriceLabel,
  g as Wrapper
};
